module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURQBS2UdwTABQ1wBR2gBS2QBQ1wBQ2gBS2QBS2gBQ1wyH2oAAAAAKdFJOU/8AQL/eYB93pzBCGhtUAAAAUklEQVQI12MQhAMGZGaxMRiYCzIIMUDBRCBTCQwcFBmEWCAqyWA6sMCZzRYQJkMoGDAoMkjCbFMEu8GABewGkG4BNpgjBRgY2DCZYmlpiai+AACmNhQbsA8XygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/prow2.png
// module id = uBsY
// module chunks = 1